import { AuthenticationService } from './AuthService/AuthenticationService';

export * from './AuthService/AuthenticationService';
export default AuthenticationService; 